import { ActivityLogFilterBar } from '@/components/common/ActivityLog/ActivityLogFilterBar';
import { ActivityLogResults } from '@/components/common/ActivityLog/ActivityLogResults';
import { useActivityLogFilters } from '@/hooks/useActivityLogFilters';
import { useAuditLogsQuery } from '@/hooks/useAuditLogsQuery';

interface AuditLogSectionProps {
  tenantId?: string;
}

export function AuditLogSection({ tenantId }: AuditLogSectionProps) {
  const filters = useActivityLogFilters(null);
  const entriesQuery = useAuditLogsQuery(filters.query, tenantId);

  return (
    <div>
      <ActivityLogFilterBar
        filters={filters}
        idPrefix={tenantId === undefined ? 'platform-activity' : 'tenant-activity'}
      />
      <ActivityLogResults
        entriesQuery={entriesQuery}
        hasActiveFilters={filters.hasActiveFilters}
        showWorkspace={tenantId === undefined}
        page={filters.page}
        pageSize={filters.query.pageSize}
        onPageChange={filters.setPage}
      />
    </div>
  );
}
